<template>
  <v-container fill-height class="my-5">
    <v-row>
      <v-col cols="12" md="12">
        <v-card outlined>
          <v-card-text>
            <v-container>
              <v-row justify="center" class="black--text">
                <v-col cols="12" md="5">
                  <div class="mb-5">
                    <h2 class="text-md-h5">
                      Pentunjuk pembuatan kelas baru
                    </h2>
                  </div>
                  <div class="mb-3">
                    <div class="foot-list-icon float-left">
                      <v-icon :color="maincolor">
                        mdi-checkbox-marked-outline
                      </v-icon>
                    </div>
                    <div class="foot-list-content">
                      Pilih <b>Mata Kuliah</b> sesuai dengan kelas yang dibuat
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="foot-list-icon float-left">
                      <v-icon :color="maincolor">
                        mdi-checkbox-marked-outline
                      </v-icon>
                    </div>
                    <div class="foot-list-content">
                      Isi <b>Nama Kelas</b> yang akan dibuat
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="foot-list-icon float-left">
                      <v-icon :color="maincolor">
                        mdi-checkbox-marked-outline
                      </v-icon>
                    </div>
                    <div class="foot-list-content">
                      Pilih <b>Jenis Kelas</b> (Reguler, PSDKU, atau MBKM)
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="foot-list-icon float-left">
                      <v-icon :color="maincolor">
                        mdi-checkbox-marked-outline
                      </v-icon>
                    </div>
                    <div class="foot-list-content">
                      Centang <b>Tim Teaching</b> jika merupakan kelas dengan pengajar lebih dari satu
                    </div>
                  </div>
                  <div class="mb-3">
                    <div class="foot-list-icon float-left">
                      <v-icon :color="maincolor">
                        mdi-checkbox-marked-outline
                      </v-icon>
                    </div>
                    <div class="foot-list-content">
                      Teknan tombol <b>'Buat'</b> untuk memproses pembuatan kelas
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
                  <v-divider vertical></v-divider>
                </v-col>
                <v-col cols="12" md="5">
                  <v-form
                    @submit.prevent="submitRegclass"
                    ref="formregclass"
                    v-model="formadd.jobclass"
                    lazy-validation>
                    <v-row justify="center" no-gutters>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-autocomplete
                              dense
                              v-model="kelassion"
                              :items="listkelas"
                              label="Mata Kuliah *"
                              :filter="filterData"
                              item-value="kelas_ID"
                              return-object
                              @change="pilihKelas()"
                              :rules="[rules.required]">
                              <template v-slot:selection="data">
                                <div class="caption">
                                  <div>
                                    <strong>{{ data.item.mataKuliah }}</strong>
                                    <br/>
                                    Kelas <b>{{ data.item.kelas }}</b>, T.A <b>{{ data.item.tahunAkademik }}</b>
                                    <br/>
                                    Prodi <b>{{ data.item.prodi }}</b>
                                  </div>
                                </div>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.mataKuliah }}</v-list-item-title>
                                  <v-list-item-subtitle>Kelas <b>{{ item.kelas }}</b>, T.A <b>{{ item.tahunAkademik }}</b></v-list-item-subtitle>
                                  <v-list-item-subtitle>Prodi <b>{{ item.prodi }}</b></v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-icon>mdi-coin</v-icon>
                                </v-list-item-action>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              dense
                              v-model="regclass.nama_class"
                              :rules="[rules.required]"
                              label="Nama Kelas *"
                              name="classname"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-autocomplete
                              dense
                              v-model="regclass.s_kelas_type"
                              :rules="[rules.required]"
                              :items="listjeniskelas"
                              label="Jenis Kelas *"
                              name="s_kelas_type">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-checkbox
                              dense
                              v-model="regclass.s_kelas_tim"
                              label="Tim Teaching?">
                            </v-checkbox>
                          </v-col>
                          <v-col cols="12" md="12">
                            <p>
                              * wajib diisi
                            </p>
                            <alertsp :alertdata="alertreg"></alertsp>
                            <v-btn
                              large
                              block
                              :loading="loading.reg"
                              :disabled="loading.reg || !formadd.jobclass"
                              :color="maincolor"
                              class="mr-4 mt-3 white--text text-capitalize"
                              type="submit">
                              Buat
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="12">
        <div class="text-center">
          <v-btn
            class="mr-2 mb-2"
            fab
            depressed
            dark
            x-small
            :to="{ name: 'ListclassDosen' }">
            <v-icon dark>
              mdi-arrow-left-thick
            </v-icon>
          </v-btn>
          <span class="title">Daftar kelas</span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { sha256, sha224 } from 'js-sha256';

export default {
  name: 'CreateclassDosen',
  data: () => ({
    alertreg: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      reg: false,
      regcom: false,
      getdata: false,
    },
    publickey: '123',
    api: process.env.VUE_APP_API,
    apision: process.env.VUE_APP_APISION,
    baseurl: process.env.VUE_APP_BASEURL,
    hash: process.env.VUE_APP_HASH,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    listtahunajaran: ['2021-2022', '2022-2023', '2023-2024'],
    listtahunangkatan: ['2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'],
    listjeniskelas: ['Reguler', 'PSDKU', 'MBKM'],
    listclsangkatan: [],
    listsemester: [1, 2, 3, 4, 5, 6, 7, 8],
    listprodi: [],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    regclass: {
      s_kelas_id: '',
      s_kelas_tim: false,
      s_kelas_type: '',
      s_kelas_ta: '',
      s_kelas_kode: '',
      nama_class: '',
      year_class: '',
      prodi_class: '',
      semester_class: '',
      matkul_class: '',
      angkatan_class: '',
      mhs_class: '',
    },
    regcompany: {
      firstname: '',
      lastname: '',
      email: '',
      companyname: '',
      companyphone: '',
      password: '',
    },
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      jobclass: false,
      company: false,
      passwordjs: false,
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    tahunaktif: process.env.VUE_APP_TH,
    listkelas: [],
    kelassion: null,
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userno',
    ]),
  },
  mounted() {
    this.getProdi();
    this.getKelasmhs();
    this.getKelassion();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    filterData(item, queryText) {
      return (
        item.mataKuliah.toLowerCase().includes(queryText.toLowerCase()) ||
        item.kelas.toLowerCase().includes(queryText.toLowerCase()) ||
        item.prodi.toLowerCase().includes(queryText.toLowerCase())
      );
    },
    pilihKelas() {
      const ksion = this.kelassion;
      // nama kelas
      this.regclass.nama_class = ksion.mataKuliah + '-' + ksion.tahunAkademik + '-' + ksion.kelas;
      this.regclass.s_kelas_id = ksion.kelas_ID;
      this.regclass.s_kelas_ta = ksion.tahunAkademik;
      this.regclass.s_kelas_kode = ksion.kodeMK;
      this.regclass.year_class = ksion.tahunAkademik;
      this.regclass.prodi_class = ksion.prodi;
      this.regclass.semester_class = ksion.semester;
      this.regclass.matkul_class = ksion.mataKuliah;
      this.regclass.mhs_class = ksion.kelas;
      // console.log(ksion);
    },
    getKelassion() {
      this.listkelas = [];
      const strhex = this.tahunaktif +
        '' + this.userno +
        '' + this.hash;
      const hashactv = sha256(strhex);
      const senddata = {
        TahunAkademik: this.tahunaktif,
        IDDosen: this.userno,
        hashCode: hashactv.toUpperCase(),
      };
      this.axios
        .post(
          this.apision + '/KelasPerkuliahaan',
          senddata,
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.responseCode === '00') {
              this.listkelas = resdata.kelasPerkuliahaan;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getProdi() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/prodi/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.listprodi = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    getKelasmhs() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kelasmhs/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.listclsangkatan = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    getJeniskerja() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitRegcompany() {
      this.alertdata.show = false;
      if (this.$refs.formregcompany.validate()) {
        if (this.publickey) {
          // console.log(this.regcompany);
          this.loading.regcom = true;
          this.axios
            .post(
              this.api + '/api/auth/regcompany',
              qs.stringify(
                this.regcompany,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.publickey,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                // console.log(res);
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formregcompany.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Congratulations <br/> your account already created <br/>';
                  this.alertdata.text += 'Please verify your email <br/> "' + resdata.data + '"<br/> Thank you';
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.regcom = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.regcom = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    submitRegclass() {
      this.alertreg.show = false;
      if (this.$refs.formregclass.validate()) {
        this.regclass.s_kelas_tim = this.regclass.s_kelas_tim ? 1 : 0;
        // console.log(this.regclass);
        if (this.tokenscr) {
          this.loading.reg = true;
          this.axios
            .post(
              this.api + '/api/kelas/',
              qs.stringify(
                this.regclass,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.$refs.formregclass.reset();
                  this.alertreg.show = true;
                  this.alertreg.type = 'success';
                  this.alertreg.text = 'Selamat, kelas "' + resdata.data + '" berhasil dibuat';
                } else {
                  this.alertreg.show = true;
                  this.alertreg.type = 'error';
                  this.alertreg.text = resdata.message;
                }
              } else {
                this.alertreg.show = true;
                this.alertreg.type = 'error';
                this.alertreg.text = 'Internal services error!';
              }
              this.loading.reg = false;
            })
            .catch((error) => {
              this.alertreg.show = true;
              this.alertreg.type = 'error';
              this.alertreg.text = 'Internal services error!';
              this.loading.reg = false;
            });
        } else {
          this.alertreg.show = true;
          this.alertreg.type = 'error';
          this.alertreg.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jeniskerja') {
        this.dmodal.jeniskerja = false;
      } else {
        this.dmodal.jeniskerja = false;
      }
    },
    editJeniskerja(item) {
      this.dmodal.jeniskerja = true;
      this.dmodaldata.jeniskerja = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.dmodaldata.jeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.jeniskerja.nama_kerja + '" berhasil diubah!';
                  this.getJeniskerja();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
